var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Profile',{attrs:{"profile":_vm.profile,"results":_vm.results}})}
var staticRenderFns = []

export { render, staticRenderFns }